module.exports = __webpack_public_path__ + "static/InterstateBlackCondensed-f4f6d3d88d07db89ffaa55f72cb85e94.woff";